import { headers, getToken } from '../../Globals'

export const loadOrders = () => {
    return async dispatch => {
        dispatch({type: "REQUESTING"})
        const resp = await fetch( 'api/orders', {
            headers: {
              ...headers,
              ...getToken()
            }
          })

          const data = await resp.json()
    
          dispatch({type: "SET_ORDERS", payload: data})
          dispatch({type: "DONE_REQUESTING"})
    }
}

export const deleteOrder = (navigate, id ) => {
  //***for fetch***//
  return async (dispatch) => {
      dispatch({type : "REQUESTING"});

      const resp = await fetch(`api/orders/${id}`, {
        method: "DELETE",
        headers: {
          ...headers,
          ...getToken()
        }}).then((r) => {
          if (r.ok) {
            dispatch({type: "DELETE_ORDER", payload: id})
          }
        });
        dispatch({ type: "DONE_REQUESTING" });
  }
}

export const addOrder = (strongParams, navigate ) => {
  console.log(strongParams)
  return async (dispatch) => {
      dispatch({type : "REQUESTING"});

      console.log(strongParams)

      const resp = await fetch('api/orders',{
          method: "POST",
      headers: {
          ...headers,
          ...getToken()
      },
      body: JSON.stringify(strongParams)
      })
      const data = await resp.json();
      console.log(data)
      if(data.errors) {
          dispatch({ type: "ERRORS", payload: data.errors })
        } else {

          dispatch({ type: "CLEAR_ERRORS" })
          dispatch({type: "ADD_ORDER", payload: data})
          navigate('/orders')
        }
        dispatch({ type: "DONE_REQUESTING" });
  }
}

